export const DOCUMENTFREEZING_FILE = 'DOCUMENTFREEZING_FILE';
// 更新
export const DOCUMENTFREEZING_UPDATE = 'DOCUMENTFREEZING_UPDATE';
